
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","version":"1.0","width":"500","height":"500","viewBox":"0 0 75 75"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.389 13.769L22.235 28.606H6v19.093h15.989l17.4 15.051V13.769z","stroke":"#111","stroke-width":"5","stroke-linejoin":"round","fill":"#111"}}),_c('path',{attrs:{"d":"M48 27.6A19.5 19.5 0 0148 49m7.1-28.5a30 30 0 010 35.6M61.6 14a38.8 38.8 0 010 48.6","fill":"none","stroke":"#111","stroke-width":"5","stroke-linecap":"round"}})])
          )
        }
      }
    